(() => {
  if (!customElements.get('tc-availability-request')) {
    customElements.define('tc-availability-request', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready) return;
        this.dataset.ready = 'true';
        const dialog = this.querySelector('dialog');
        this.querySelector('[data-tc-open]')?.addEventListener('click', () => dialog.showModal());
        this.querySelector('[data-tc-close]')?.addEventListener('click', () => dialog.close());
        dialog?.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      }
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-tc-submit]');
    if (!button) return;
    const sticky = button.closest('[data-tc-sticky]');
    const form = document.getElementById(sticky.dataset.formId);
    const nativeButton = form?.querySelector('button[name="add"]');
    if (!form || !nativeButton || nativeButton.disabled || form.querySelector('input[name="id"]')?.disabled) return;
    form.requestSubmit(nativeButton);
  });
  document.addEventListener('submit', event => {
    const form = event.target.closest('[data-tc-filters]');
    if (!form) return;
    event.preventDefault();
    const tags = [form.querySelector('[data-tc-height]')?.value, form.querySelector('[data-tc-finish]')?.value, form.querySelector('[data-tc-group]')?.value].filter(Boolean);
    const url = new URL(form.dataset.collectionUrl + (tags.length ? '/' + tags.map(encodeURIComponent).join('+') : ''), location.origin);
    if (form.dataset.sort) url.searchParams.set('sort_by', form.dataset.sort);
    location.assign(url.href);
  });
  const bindSticky = () => {
    const info = document.querySelector('product-info[id^="MainProduct-"]');
    const target = info?.querySelector('.product-form__buttons');
    if (!target || info.dataset.tcObserved) return;
    info.dataset.tcObserved = 'true';
    const observer = new IntersectionObserver(entries => {
      const entry = entries[0];
      info.classList.toggle('tc-past-purchase', !entry.isIntersecting && entry.boundingClientRect.bottom < 0);
    }, { threshold: 0 });
    observer.observe(target);
  };
  document.addEventListener('product-info:loaded', bindSticky);
  document.addEventListener('shopify:section:load', bindSticky);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', bindSticky); else bindSticky();
  if (location.search.includes('contact_posted=true')) {
    document.querySelector('tc-availability-request dialog')?.showModal();
  }
})();
